import { Schema } from "effect";
import type { Scope } from "effect";
import { WorkspaceTarget, type WorkspaceDraft } from "./persistence-model.ts";

export const SavePhase = Schema.Literals(["idle", "saving", "saved", "error"]);
export type SavePhase = typeof SavePhase.Type;
export const PendingSaveSnapshot = Schema.Struct({
  phase: SavePhase, pending: Schema.NullOr(WorkspaceTarget), closed: Schema.Boolean
});
export type PendingSaveSnapshot = typeof PendingSaveSnapshot.Type;
export interface PendingEdit {
  readonly identity: object;
  readonly target: WorkspaceTarget;
  readonly draft: WorkspaceDraft;
}
export interface PendingSaveState {
  readonly pending: PendingEdit | null;
  readonly phase: SavePhase;
  readonly timer: Scope.Closeable | null;
  readonly closed: boolean;
}
export const pendingSaveSnapshot = (state: PendingSaveState): PendingSaveSnapshot => ({
  phase: state.phase, pending: state.pending?.target ?? null, closed: state.closed
});
